angular.
module("dx.webapp.client").
controller("DxClientSettingsRouteController", function ClientSettingsRouteController(
	$rootScope,

	dxApi,
	dxClientVersionSort,

	DX_OS,
	dxDialog
) {
	"use strict";

	var self = this;
	var versionNumberRegex = /^(\d{1,3}\.){2}\d{1,3}$/;

	this.DX_OS = DX_OS;
	this.DX_ARCH = ["x86", "x86_64", "universal", "aarch64", "unspecified"];

	self.version = "";
	self.platform = "";
	self.buildKey = "";
	self.saving = false;
	self.errorMessage = "";
	self.clients = [];
	self.architecture = "";

	dxApi.v1.clientversions.get().then(function onResolve(response) {
		self.clients = response.data.sort(dxClientVersionSort);
	});

	self.saveEnabled = function saveEnabled() {
		return versionNumberRegex.test(self.version) && self.platform && self.buildKey && self.architecture;
	};

	function onSaveResolve(response) {
		self.saving = false;

		self.clients.push(response.data);
		self.clients = self.clients.sort(dxClientVersionSort);

		self.version = "";
		self.platform = "";
		self.buildKey = "";
		self.architecture = "";
	}

	function onSaveReject(response) {
		self.saving = false;
		self.errorMessage = "Error: " + response.data.message;
	}

	self.saveVersion = function saveVersion() {
		self.saving = true;
		self.errorMessage = "";

		dxApi.v1.clientversions.post(self.version, self.platform, self.buildKey, self.architecture).
			then(onSaveResolve, onSaveReject);
	};

	function updateVersion(clientToSave) {
		dxDialog.closeMostRecent();
		clientToSave.deprecationTimeIsSet = !!clientToSave.deprecationTime;
		dxApi.v1.clientversions.put(clientToSave);
	}

	self.showDeprecationPopup = function showDeprecationPopup(client) {
		var scope = $rootScope.$new();
		scope.client = client;
		scope.onSave = updateVersion;

		dxDialog.show({
			templateUrl: "tmpl/client/deprecation-popup.html",
			$scope: scope,
			clickOutsideToClose: false,
		});
	};

	self.showDeleteConfirm = function showDeleteConfirm(client) {
		function deleteConfirmed() {
			dxDialog.closeMostRecent();
			dxApi.v1.clientversions.delete(client.id).then(function onResolve() {
				var indexToRemove = -1;

				for (var i = 0; i < self.clients.length; i++) {
					if (self.clients[i] === client) {
						indexToRemove = i;
						break;
					}
				}

				self.clients.splice(indexToRemove, 1);
			});
		}

		dxDialog.confirm({
			title: "Delete " + client.versionNumber + "/" + client.platform + "?",
			body: "Are you sure you want to delete version " + client.versionNumber + " for " + client.platform + "?",
			acceptText: "Delete",
			acceptCallback: deleteConfirmed,
			rejectText: "Cancel",
			actionIsDangerous: true,
		});
	};
});
